<template>
  <v-sheet>
    <PageTemplate
      ><v-container class="pb-16">
        <Title class="text-center mb-6 mb-lg-8">Download de Arquivos</Title>
        <v-simple-table v-if="filesDown.length">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nome</th>
                <th class="text-end">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="({ title, file }, i) in filesDown" :key="i">
                <td>{{ title }}</td>
                <td class="text-end">
                  <a
                    @click="
                      downloadWithAxios(files + file, title, file.split('.')[1])
                    "
                  >
                    <v-icon>fas fa-download</v-icon>
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card
          class="py-8 text-center white--text elevation-0"
          color="warning"
          v-else
          >Nenhum arquivo encontrado.</v-card
        >
      </v-container></PageTemplate
    >
  </v-sheet>
</template>

<script>
import axios from "axios";
import Title from "../widgets/Title.vue";
import PageTemplate from "../templates/Page.vue";
export default {
  components: {
    PageTemplate,
    Title,
  },
  computed: {
    filesDown() {
      return this.$rest("files-download").list;
    },
  },
  methods: {
    forceFileDownload(response, title, type) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      switch (type) {
        case "pdf":
          link.setAttribute("download", title + ".pdf");
          break;
        case "png":
          link.setAttribute("download", title + ".png");
          break;
        case "jpg":
          link.setAttribute("download", title + ".jpg");
          break;
        case "jpeg":
          link.setAttribute("download", title + ".jpeg");
          break;
        case "svg":
          link.setAttribute("download", title + ".svg");
          break;
        default:
          link.setAttribute("download", title);
      }

      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(url, title, type) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title, type);
        })
        .catch(() => console.log("error occured"));
    },
  },
  mounted() {
    this.$rest("files-download").get();
  },
};
</script>

<style></style>
